export default __webpack_public_path__ + "static/media/vid.bf10d86f.svg";